// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"CancelConfirmButtons_buttonsContainer__-KWi7","cancel":"CancelConfirmButtons_cancel__eivUd","confirm":"CancelConfirmButtons_confirm__HbkJg"};